module.exports = __webpack_public_path__ + "static/media/3.1168795b.mp3";